export default {"src":"/_next/static/media/serviceCenterHeaderIcon.d0ab026a.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};